import React, { lazy, Suspense } from "react";
import LazyLoader from "../../components/common/loader/lazyLoader";
const ListSubSubCategory = lazy(() =>
  import("../../components/subSubCategory/listSubSubCategory")
);

const ListSubSubCategoryPage = () => {
  return (
    <Suspense fallback={<LazyLoader />}>
      <ListSubSubCategory />
    </Suspense>
  );
};

export default ListSubSubCategoryPage;
